import { wsService } from "./wsService";

const section = "notifications/push";

function isSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

function isInstalled() {
  return window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;
}

// En iPhone/iPad las push solo existen con la app instalada en la pantalla de inicio
function needsInstall() {
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform == "MacIntel" && navigator.maxTouchPoints > 1);
  return ios && !isInstalled();
}

function permission() {
  return "Notification" in window ? Notification.permission : "default";
}

// Devuelve { public_key }. Sin clave, el backend no tiene configuradas las push
function config() {
  return wsService.make_post_request(section + "/config", {});
}

async function getRegistration() {
  if (!("serviceWorker" in navigator)) return null;
  return (await navigator.serviceWorker.getRegistration()) || null;
}

async function getSubscription() {
  const registration = await getRegistration();
  return registration && registration.pushManager ? registration.pushManager.getSubscription() : null;
}

function keyToBytes(key) {
  const base64 = (key + "=".repeat((4 - (key.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(window.atob(base64), (char) => char.charCodeAt(0));
}

function send(path, subscription) {
  return wsService.make_post_request(section + path, subscription.toJSON()).then((response) => {
    if (!response.status) throw new Error(response.msg);
    return response;
  });
}

// Pide el permiso: llamarla solo desde un click del usuario. Devuelve false si no lo dio
async function enable() {
  const response = await config();
  if (!response.status || !response.result.public_key) throw new Error("Las notificaciones no están disponibles.");

  if ((await Notification.requestPermission()) != "granted") return false;

  const registration = await getRegistration();
  if (!registration) throw new Error("Las notificaciones no están disponibles.");

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: keyToBytes(response.result.public_key),
  });

  try {
    await send("/subscribe", subscription);
  } catch (e) {
    await subscription.unsubscribe();
    throw e;
  }
  return true;
}

async function disable() {
  const subscription = await getSubscription();
  if (!subscription) return;
  await send("/unsubscribe", subscription);
  await subscription.unsubscribe();
}

// Al iniciar la app: deja la suscripcion de este dispositivo a nombre del usuario logueado
async function sync() {
  const subscription = await getSubscription();
  if (subscription) await send("/subscribe", subscription);
}

// Al cerrar sesion: el dispositivo deja de recibir. El backend borra el registro en el proximo envio
async function forgetDevice() {
  const subscription = await getSubscription();
  if (subscription) await subscription.unsubscribe();
}

export const pushService = {
  isSupported,
  needsInstall,
  permission,
  config,
  getSubscription,
  enable,
  disable,
  sync,
  forgetDevice,
};
